import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const ACCOUNT_LOAD_ADMIN_QUERY_KEY = '/admin/account/<accountId>';

export function useAccountLoadAdmin({
	accountId,
	meta,
	enabled = true,
}: {
	accountId: string;
	meta?: LevStandardQueryMeta;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			new Promise<Api.IAccount>((resolve, reject) =>
				userSession.webServiceHelper.callWebServiceWithOperationResults<Api.IAccount>(
					`admin/account/${encodeURIComponent(accountId)}`,
					'GET',
					null,
					opResult => {
						resolve(opResult.value);
					},
					opResult => {
						reject(opResult);
					}
				)
			),
		queryKey: [ACCOUNT_LOAD_ADMIN_QUERY_KEY, accountId],
		meta,
		enabled,
	});
}

export const invalidateAccountLoadAdmin = () => {
	reactQueryClient.invalidateQueries({ queryKey: [ACCOUNT_LOAD_ADMIN_QUERY_KEY] });
};
